import { render, staticRenderFns } from "./imgs.vue?vue&type=template&id=892f921a&scoped=true&"
import script from "./imgs.vue?vue&type=script&lang=js&"
export * from "./imgs.vue?vue&type=script&lang=js&"
import style0 from "./imgs.vue?vue&type=style&index=0&id=892f921a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892f921a",
  null
  
)

export default component.exports